import React from "react";

// import Icons from "../../../icons/icons";
// import { StorageContext } from "../../../storage/storage-context";

interface AutocompleteInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  init?: string, //{ [key: string]: string},
  suggestions?: string[],
  badge?: JSX.Element
}


const AutocompleteInput: React.FC<AutocompleteInputProps> = ({ value, name, placeholder, onChange, init = '', suggestions = [], badge, className, ...rest}) => {
  
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [inputElementValue, setInputElementValue] = React.useState<{ value: string }>({ value: init });

  const [hasFocus, setHasFocus] = React.useState<boolean>(false);
  const [modelValue, setModelValue] = React.useState<{ value: string }>({ value: init });

  const [filteredSuggestions, setFilteredSuggestions] = React.useState<string[]>([]);

  React.useEffect(() => {
    const _filteredSuggestions = suggestions.filter(suggestion => suggestion.toLowerCase().startsWith(modelValue.value.toLowerCase()) && modelValue.value !== suggestion);

    if (inputRef.current) {
      // const prevSelectionStart = inputRef.current.selectionStart || 0;
      
      // if ((prevSelectionStart === modelValue.value.length)) {
      //   console.log('setting selection range decreased', modelValue.value.length -1, inputElementValue.value.length);
      //   inputRef.current.setSelectionRange(modelValue.value.length - 1, inputElementValue.value.length)
      // } else {
        // console.log('setting selection range', modelValue.value.length, inputElementValue.value.length);
        inputRef.current.setSelectionRange(modelValue.value.length, inputElementValue.value.length)
      // }
    }
    setFilteredSuggestions(_filteredSuggestions);
  }, [inputElementValue])
  
  React.useLayoutEffect(() => {
    // console.log('modelValue', modelValue);
    const _filteredSuggestions = suggestions.filter(suggestion => suggestion.toLowerCase().startsWith(modelValue.value.toLowerCase()) && modelValue.value !== suggestion);

    modelValue.value.length ? 
      setInputElementValue({ value: modelValue.value + (_filteredSuggestions[0] ? _filteredSuggestions[0].substring(modelValue.value.length) : '')})
    :
      setInputElementValue({value: ''});

    if (onChange && inputRef.current) {
      const event = {
        target: {
          value: modelValue.value,
        }
      } as React.ChangeEvent<HTMLInputElement>;
      onChange(event);
    }
  }, [modelValue]);

  React.useEffect(() => {
    // console.log('hasFocus', hasFocus);
    hasFocus ?
      setFilteredSuggestions(suggestions.filter(suggestion => suggestion.toLowerCase().startsWith(modelValue.value.toLowerCase()) && modelValue.value !== suggestion))
    :
      setModelValue({ value: inputElementValue.value });
  }, [hasFocus])

  return (
    <div className="relative mb-2">
      <input
        ref={inputRef}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setModelValue({ value: e.target.value })}}
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.key === 'Backspace' || e.key === 'Delete') {
            e.preventDefault();
            setModelValue({ value: inputElementValue.value.substring(0, (inputRef.current?.selectionStart || 1) - 1) });
            inputRef.current?.setSelectionRange((inputRef.current.selectionStart || 1) - 1, inputElementValue.value.length);
          }
        }}
        value={inputElementValue.value}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setTimeout(() => setHasFocus(false), 500)}
        type={'text'}
        className={`w-full px-4 py-2 rounded-lg ${badge ? 'pr-10' : ''} ${className}`}
        placeholder={placeholder}
        {...rest}
      />
      { (hasFocus && filteredSuggestions.length > 0) &&
        <div className="absolute z-10 left-0 right-0 bg-white border border-gray-300 max-h-60 overflow-y-auto rounded-b-lg">
          { filteredSuggestions.map((suggestion, index) => (
            <div 
              key={index}
              className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
              onClick={() => {
                // console.log('clicked suggestion', suggestion);
                setModelValue({ value: suggestion });
                setFilteredSuggestions([]);
              }}
            >
              {suggestion}
            </div>
          )) }
        </div>
      }
      { badge &&
        <div
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-current h-10 w-6 flex items-center justify-center"
        >
          <span>{ badge }</span>
        </div>
      }

    </div>
  )
}

export default AutocompleteInput;